import gsap from 'gsap';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    TITLE: '.js-p-title',
    CONTENT_ELEMENT: '.js-p-content-element',
};

const init = () => {
    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline.fromTo(ANIMATION_SELECTORS.TITLE, { yPercent: 80 }, { yPercent: 0, opacity: 1 }).to(
        ANIMATION_SELECTORS.CONTENT_ELEMENT,
        {
            opacity: 1,
            stagger: DEVICE_WIDTH.isDesktop ? 0.4 : 0,
            onStart: () => {
                const firstActiveBlock = document.querySelector('.js-o-block.first-active-block');

                if (firstActiveBlock) {
                    const collapse = document.querySelector('.js-o-block-collapse');

                    if (collapse) {
                        gsap.set(collapse, { height: collapse.scrollHeight });
                    }
                }
            },
        },
        '-=0.4',
    );
};

const _module = { init };

export default _module;
